import { Link } from 'react-router-dom';

export const formatTimeAgo = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diff = now - date;
  if (diff < 60000) return 'now';
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h`;
  if (diff < 604800000) return `${Math.floor(diff / 86400000)}d`;
  return date.toLocaleDateString();
};

export const parseContent = (content) => {
  if (!content) return content;
  const parts = content.split(/(\s+)/);
  return parts.map((part, index) => {
    if (part.startsWith('#')) {
      return (
        <Link key={`hash-${index}-${part}`} to={`/hashtag/${part.slice(1)}`} className="text-[#4A90E2] hover:underline font-medium">
          {part}
        </Link>
      );
    }
    if (part.startsWith('@')) {
      return (
        <Link key={`mention-${index}-${part}`} to={`/profile/${part.slice(1)}`} className="text-[#A855F7] hover:underline font-medium">
          {part}
        </Link>
      );
    }
    return part;
  });
};

export const reactions = [
  { type: 'like', icon: '❤️', label: 'Like' },
  { type: 'love', icon: '😍', label: 'Love' },
  { type: 'fire', icon: '🔥', label: 'Fire' },
  { type: 'laugh', icon: '😂', label: 'Haha' },
  { type: 'wow', icon: '😮', label: 'Wow' },
  { type: 'sad', icon: '😢', label: 'Sad' },
];

export const getPlatformIcon = (platform, icons) => icons[platform] || null;
